<pp-modal [zIndex]="zIndex">
  <ng-container heading>
    {{ heading }}
  </ng-container>

  <ng-container body>
    <p
      [class.modal__bold]="boldText"
      [class.modal__extra-padding-top]="extraPadding"
      [innerHTML]="message"
    ></p>
    @if (secondaryMessage) {
      <p
        class="modal__secondary"
        [class.modal__bold]="boldSecondaryText"
        [innerHTML]="secondaryMessage"
      ></p>
    }
    @if (showCheckbox) {
      <div class="confirmModal__checkbox-container">
        <pp-checkbox
          [ppChecked]="dontShowAgain"
          ppSize="large"
          ppType="solid"
          (ppOnValueChange)="dontShowAgainChecked()"
        ></pp-checkbox>
        <p class="confirmModal__checkbox-text" [innerHTML]="checkboxText"></p>
      </div>
    }
  </ng-container>

  <ng-container footer>
    <pp-modal-generic-footer
      [ppConfirmText]="confirmText"
      (ppCancel)="hideModal(true)"
      (ppConfirm)="hideModal(false)"
      [ppError]="redButton"
      [ppHideCancel]="hideCancel"
      [ppCancelText]="cancelText"
    ></pp-modal-generic-footer>
  </ng-container>
</pp-modal>
